/* eslint-disable no-unused-vars */
// eslint-disable-next-line max-len
import constants from "../constants/constants";
import lcrInScan from "../assests/images/middleMile/lcr-in-scan.svg";
import lcrGen from "../assests/images/middleMile/lcr-gen.svg";
import bagging from "../assests/images/middleMile/bagging.svg";
import Sorting from "../assests/images/middleMile/sorting.svg";
import AddCategory from "../assests/images/addCategory.svg";
import openBag from "../assests/images/middleMile/open-bag.svg";
import openPackets from "../assests/images/middleMile/open-packet.svg";
import sortToCp from "../assests/images/middleMile/sort-to-cp.svg";
import mm_inscan from "../assests/images/SVG/mm-in-scan.svg";
import packeting from "../assests/images/SVG/packeting.svg";
import my_order from "../assests/images/my-order.svg";
import product_request from "../assests/images/product-request.svg";
import orderRequest from "../assests/images/OrderRequest.svg";
import addProduct from "../assests/images/addProduct.svg";
import createDelivery from "../assests/images/SVG/createDelivery.svg";
import generateDRS from "../assests/images/SVG/generateDRS.svg";
import excess from "../assests/images/SVG/excess.svg";

// import  from "../assests/images/middleMile/lcr-gen.svg";

import audit from "../assests/images/SVG/audit-dash.svg";

const { ROLES } = constants;
const { HUB_ADMIN, HO_ADMIN, CP_ADMIN } = ROLES;

export const SubPathHubInbound = [
  {
    imgSrc: mm_inscan,
    title: "In Scan",
    id: "in-scan",
    additionalClass: "",
    route: "/consolidated-manifest",
    role: [HUB_ADMIN],
  },
  {
    imgSrc: Sorting,
    title: "Sort Shipment",
    id: "view-audit",
    additionalClass: "",
    route: "/sort-shipment",
    role: [HUB_ADMIN],
  },
  {
    imgSrc: packeting,
    title: "Packeting",
    id: "view-audit",
    additionalClass: "",
    route: "/packeting",
    role: [HUB_ADMIN],
  },
  {
    imgSrc: bagging,
    title: "Bagging",
    id: "view-audit",
    additionalClass: "",
    route: "/shipment-bagging",
    role: [HUB_ADMIN],
  },
  {
    imgSrc: lcrGen,
    title: "LCR Generation",
    id: "view-audit",
    additionalClass: "",
    route: "/create-or-update-trip",
    role: [HUB_ADMIN],
  },
  // {
  //   imgSrc: sortToCp,
  //   title: "CP Wise Sorting",
  //   id: "my-order",
  //   additionalClass: "",
  //   route: "/sort-to-cp",
  //   role: [HUB_ADMIN],
  // },
];

export const SubPathHubOutbound = [
  {
    imgSrc: lcrInScan,
    title: "LCR IN-Scan",
    id: "out-scan-hub",
    additionalClass: "",
    route: "/lcr-list-in-scan",
    role: [HUB_ADMIN],
  },
  {
    imgSrc: openBag,
    title: "Open Bags",
    id: "out-scan-hub",
    additionalClass: "",
    route: "/lcr-scanned-bags",
    role: [HUB_ADMIN],
  },
  {
    imgSrc: openPackets,
    title: "Open Packets",
    id: "out-scan-hub",
    additionalClass: "",
    route: "/scan-packets",
    role: [HUB_ADMIN],
  },

  {
    imgSrc: sortToCp,
    title: "Out-scan to CP",
    id: "my-order",
    additionalClass: "",
    route: "/sort-to-cp",
    role: [HUB_ADMIN],
  },
  // {
  //   component: GenerateManifestTabs,
  //   route: "/generateManifest",
  //   role: [HUB_ADMIN],
  // },
  {
    imgSrc: generateDRS,
    title: "Generate Manifest",
    id: "my-order",
    additionalClass: "",
    route: "/generateManifest",
    role: [HUB_ADMIN],
  },
  // {
  //   imgSrc: lcrInScan,
  //   title: "Generate Manifest",
  //   id: "my-order",
  //   additionalClass: "",
  //   route: "/generateManifest",
  //   role: [HUB_ADMIN],
  // },
];

export const SubPathConfiguration = [
  {
    imgSrc: Sorting,
    title: "Sorting Guide",
    id: "sorting-guide",
    additionalClass: "",
    route: "/sorting-guide",
    role: [HUB_ADMIN],
  },
];

export const SubPathStationery = [
  {
    imgSrc: product_request,
    title: "Order Products",
    id: "my-order",
    additionalClass: "",
    route: "/product-list",
    role: [HUB_ADMIN, CP_ADMIN],
  },
  {
    imgSrc: my_order,
    title: "My Orders",
    id: "my-order",
    additionalClass: "",
    route: "/order-history",
    role: [HUB_ADMIN, CP_ADMIN],
  },
  {
    imgSrc: AddCategory,
    title: "Add Categories",
    id: "my-order",
    additionalClass: "",
    route: "/add-category",
    role: [HO_ADMIN],
  },
  {
    imgSrc: orderRequest,
    title: "Order Request",
    id: "my-order",
    additionalClass: "",
    route: "/order-request",
    role: [HO_ADMIN],
  },
  {
    imgSrc: addProduct,
    title: "Add Product",
    id: "my-order",
    additionalClass: "",
    route: "/product",
    role: [HO_ADMIN],
  },
];

//lastMile
export const SubPathLastMileOperations = [
  {
    imgSrc: mm_inscan,
    title: "In Scan Shipments",
    id: "in-scan-cp",
    additionalClass: "",
    route: "/in-scan-cp",
    role: [CP_ADMIN],
  },

  {
    imgSrc: generateDRS,
    title: "Generate DRS",
    id: "generate-drs",
    additionalClass: "",
    route: "/generate-drs",
    role: [CP_ADMIN],
  },
  {
    imgSrc: mm_inscan,
    title: "Pending for DRS",
    id: "pending-for-drs",
    additionalClass: "",
    route: "/pending-drs",
    role: [CP_ADMIN],
  },
  // {
  //   imgSrc: excess,
  //   title: "Excess of Scan",
  //   id: "excess-of-scan",
  //   additionalClass: "",
  //   route: "/excess-of-scan",
  //   role: [CP_ADMIN],
  // },

  {
    imgSrc: createDelivery,
    title: "Create Delivery Area",
    id: "create-virtual-area",
    additionalClass: "",
    route: "/create-virtual-area",
    role: [CP_ADMIN],
  },
];
